export default {
  // facebook: "fab fa-facebook",
  // twitter: "fab fa-twitter",
  linkedin: "fab fa-linkedin-in",
};
